import { SET_ST_SUPPLIER_DATA, ADD_ST_SUPPLIER_DATA, DELETE_ST_SUPPLIER_DATA, EDIT_ST_SUPPLIER_DATA, ADD_COUNTRIES, UPDATE_COUNTRIES, ADD_STATES } from "./types";

export const setSTSupplierData = (payload) => {
  return {
    type: SET_ST_SUPPLIER_DATA,
    payload: payload,
  };
};

export const addSTSupplierData = (payload) => {
  return {
    type: ADD_ST_SUPPLIER_DATA,
    payload: payload,
  };
};
export const deleteSTSupplierData = (payload) => {
  return {
    type: DELETE_ST_SUPPLIER_DATA,
    payload: payload,
  };
};
export const editSTSupplierData = (payload) => {
  return {
    type: EDIT_ST_SUPPLIER_DATA,
    payload: payload,
  };
};
export const addCountries = (payload) => {
  return {
    type: ADD_COUNTRIES,
    payload: payload,
  };
};
export const updateCountries = (payload) => {
  return {
    type: UPDATE_COUNTRIES,
    payload: payload,
  };
};
export const addStates = (payload) => {
  return {
    type: ADD_STATES,
    payload: payload,
  };
};